import PageTitle from '../components/PageTitle';
import Q2OperatingResults2025 from '../components/content/tables/Operations-q2';

import Section from '../components/Section';
import ContentTypeNav from 'components/ContentTypeNav';

const Q2OperationsSummary = () => {
	return (
		<>
			<PageTitle title="Operations Summary" />

			<div className="bg-[#4B7B9D] text-white py-12 md:py-24 px-4 sm:px-6">
				<div className="mx-auto max-w-[1068px]">
					<div className="md:max-w-[835px]">
						<ContentTypeNav type="operations" />
						<p className="font-late-serif text-[1.375rem] md:text-[1.65rem] leading-[1.6] mb-6">We write personal and commercial insurance, and other specialty property-casualty insurance, throughout the United States through independent insurance agencies and directly to consumers and provide related services. Our Personal Lines segment writes insurance for personal autos, special lines products (e.g., recreational vehicles, such as motorcycles, RVs, and watercraft), and personal residential property insurance for homeowners and renters. Our Commercial Lines segment writes auto-related liability and physical damage insurance, business-related general liability and commercial property insurance predominantly for small businesses, and workers’ compensation insurance primarily for the transportation industry.</p>
					</div>
				</div>
			</div>

			<Section backgroundColor="#F6FAF9">
				<div className="container pt-12 md:pt-24 max-w-container-md">
					<h2 className="font-trade-compressed uppercase m-0 text-[#F05860] text-[1.875rem] font-bold tracking-widest">OPERATING RESULTS</h2>
				</div>
				<div className="w-full pb-24 max-w-[100vw]">
					<div className="container max-w-container-lg">
						<Q2OperatingResults2025 />
					</div>
				</div>
			</Section>
		</>
	);
};

export default Q2OperationsSummary;
